<template>
  <!-- 分区管理-编辑地图 -->
  <a-row :gutter="24">
    <a-col :span="12">
      <a-card :bordered="false">
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="48">
              <a-col :md="14" :sm="24">
                <a-col :md="35" :sm="24" v-if="this.$store.state.user.info.systemAdmin">
                  <a-form-item label="水司">
                    <a-select placeholder="请选择" default-value v-model="query.tenantId" allow-clear>
                      <a-select-option value>全部</a-select-option>
                      <a-select-option v-for="item in tenantList" :key="item.tenantId" :value="item.tenantId">
                        {{ item.tenantName }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <span class="table-page-search-submitButtons">
                  <a-button type="primary" @click="queryList" v-action:find>查询</a-button>
                  <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()"
                    v-action:add>新增</a-button>
                    <!-- v-action:recycle -->
                  <a-button type="primary" icon="hdd" style="margin-left: 8px" @click="recycleBinVisible = true"
                    >回收站</a-button>
                  <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <a-table :pagination="false" rowKey="id" bordered
          :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
          :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="list"
          :columns="columns" :loading="dataListLoading">
          <span slot="parent" slot-scope="text, record">{{ record.parentName || '一级片区' }}</span>
          <!-- <span slot="customColor" slot-scope="text, record">
            <input type="color" v-model="text" disabled>
          </span> -->
          <span slot="action" slot-scope="text, record">
            <a @click="addOrUpdateHandle(record.id)" v-action:edit>编辑</a>
          </span>
          <span slot="zoneAction" slot-scope="text, record">
            <span v-if="text != '一级分区'">{{ numberParseChina(record.level) }}级分区 — {{ text }}</span>
            <span v-else>{{ text }}</span>
          </span>
        </a-table>
        <a-modal title="操作" style="top: 20px" :width="900" destroyOnClose v-model="addOrUpdateVisible"
          @ok="handleFormOk" @cancel="handleCancel">
          <a-form-model class="tenant-form" :model="addOrUpdateForm" ref="addOrUpdateForm" :rules="rules">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上级片区" prop="pid">
              <a-tree-select :tree-data="treeData" v-model="addOrUpdateForm.pid" style="width: 100%"
                :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择上级片区" allow-clear
                :treeDefaultExpandedKeys="treeDefaultExpandedKeys" show-search @change="pidChange"
                treeNodeFilterProp="title"></a-tree-select>
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="片区名称" hasFeedback prop="zoneName">
              <a-input placeholder="请输入片区名称" v-model="addOrUpdateForm.zoneName" />
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="片区编号">
              <a-input placeholder="请输入片区编号" v-model="addOrUpdateForm.zoneCode" />
            </a-form-model-item>

            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="售水量" prop="sellWater">
              <a-input placeholder="请输入售水量" v-model="addOrUpdateForm.sellWater" />
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="颜色" prop="customColor">

              <input type="color" v-model="addOrUpdateForm.customColor"
                :disabled="addOrUpdateForm.level == 1 ? true : false">
              <a-input placeholder="请输入颜色值" v-model="addOrUpdateForm.customColor"
                :disabled="addOrUpdateForm.level == 1 ? true : false" />
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="漏损率">
              <a-input-number style="width: 100%" placeholder="请输入漏损率" v-model="addOrUpdateForm.leakageRate" />
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="大屏步长">
              <a-input-number style="width: 100%" placeholder="请输入大屏步长" v-model="addOrUpdateForm.stepLength" />
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="水表流量底吨">
              <a-input-number style="width: 100%" placeholder="请输入水表流量底吨" v-model="addOrUpdateForm.bottomTon" />
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="夜间2-5时总流量">
              <a-input-number style="width: 100%" placeholder="请输入夜间2-5时总流量" v-model="addOrUpdateForm.nightTotalFlow" />
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="排序值">
              <a-input-number style="width: 100%" placeholder="排序值" v-model="addOrUpdateForm.sort" />
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否启用片区流量监控数据">
              <a-select placeholder="是否启用片区流量监控数据" style="width: 200px" v-model="addOrUpdateForm.startUsing">
                <a-select-option :value="0">不启用</a-select-option>
                <a-select-option :value="1">启用</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="DMA片区">
              <a-switch v-model="addOrUpdateForm.areaDma" :checked-children="'是'" :un-checked-children="'否'"
                :checkedValue="1" :unCheckedValue="0" />
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="地图选点" prop="geoJson">
              <a-button type="default" @click="showEditPopup">展开地图</a-button>
            </a-form-model-item>
          </a-form-model>
        </a-modal>
        <a-modal v-model="mapVisible" class="my-map-component" :title="null" :closable="false"
          :bodyStyle="{ padding: 0 }" width="100%" :mask="false" :dialogStyle="{ top: 0, margin: 0, padding: 0 }"
          destroyOnClose @cancel="handleCancel" :footer="null">

          <div style="height: calc(100vh)">
            <zoneMap :layerLevelList="layerLevelList" :currentId="currentId" @insert-form-geoJson="getFormGeoJson"
              :geoJson="addOrUpdateForm.geoJson" :level="addOrUpdateForm.level" @quit-redact="handleCancel"
              :parentZoneId="addOrUpdateForm.zoneId">
            </zoneMap>
          </div>
        </a-modal>
        <ZoneRecycleBinModal :visible.sync="recycleBinVisible" @ok="modalFormOk" />
      </a-card>
    </a-col>
    <a-col :span="12">
      <a-card :bordered="false">
        <mind :gData="gData" @zone-data-update="handleZoneData" />
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import mixinViewModule from '@/mixin/commonModel'
import CollectionMap from '@/components/map/CollectionMap.vue'
import zoneMap from '@/components/map/zoneMap.vue'
import mind from './component/mind.vue'
import ZoneRecycleBinModal from './component/ZoneRecycleBinModal.vue'
import { getUUID } from '@/utils/util'
const columns = [
  {
    title: '分区名称',
    dataIndex: 'zoneName',
    align: 'left',
    scopedSlots: { customRender: 'zoneAction' },
  },
  {
    title: '片区编号',
    dataIndex: 'zoneCode',
  },
  {
    title: '级别',
    dataIndex: 'level',
  },
  {
    title: '售水量',
    dataIndex: 'sellWater',

  },
  {
    title: '排序值',
    dataIndex: 'sort'
  },
  {
    title: '操作',
    width: '150px',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
]
const columns2 = [
  {
    title: '关联点号',
    dataIndex: 'connectionPointNumber',
  },
  {
    title: '关联点名称',
    dataIndex: 'featurePoint',
  },
]
const list = []
function transTree (list) {
  return list.map((v) => {
    return { id: v.id, zoneName: v.zoneName, children: v.children ? transTree(v.children) : [] }
  })
}
export default {
  components: { CollectionMap, mind, zoneMap, ZoneRecycleBinModal },
  mixins: [mixinViewModule],
  name: 'ManagementList',
  data () {
    return {
      mapTypeName: '高德地图',
      layerLeval: '分区选择',
      isShowFM: true,
      fm: '隐藏',
      isShowLLJ: true,
      llj: '隐藏',
      isShowGW: true,
      gw: '隐藏',
      isShowFQ: true,
      fqText: '隐藏',
      layerLevelList: [],
      selectId: '',
      columns2,
      pipNetWorkList: [],
      stabilizePipNetWorkList: [],
      pagination2: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
      },
      dataListLoading: false,
      id: '',
      fileList: [],
      tenantList: [],
      query: {
        tenantId: this.$store.state.user.info.tenantId,
      },
      queryUrl: 'zone-metering/zone-metering/tree',
      addOrUpdateUrl: 'zone-metering/zone-metering',
      queryOneUrl: 'zone-metering/zone-metering',
      deleteUrl: 'zone-metering/zone-metering',
      needPage: false,
      columns,
      geo: '{}',
      mapVisible: false,
      addOrUpdateForm: {
        id: '',
        zoneId: '',
        pid: '0',
        zoneName: '',
        zoneCode: '',
        zoneType: 2,
        geoJson: '{}',
        level: 0,
        sort: '',
        sellWater: '',
        leakageRate: '',
        customColor: '',
        startUsing: 0,
        nightTotalFlow: '',
        isDmaZone: false,
        areaDma: 0
      },
      listIndex: {},
      labelCol: { xs: { span: 24 }, sm: { span: 5 } },
      wrapperCol: { xs: { span: 24 }, sm: { span: 16 } },
      treeDefaultExpandedKeys: [], // 默认展开的树节点
      recycleBinVisible: false,
    }
  },
  created () {
    this.getAllTenant()
    this.initLayerLevel()
  },
  computed: {
    treeData () {
      return [
        {
          id: '0',
          zoneName: '一级片区',
          children: this.filterTree(this.list, this.currentId),

        },
      ]
    },
    gData () {
      return transTree(this.list)
    },
    rules () {
      return {
        level: [{ required: true, pattern: /^[0-9]+\.?[0-9]*$/, message: '请输入数字' }],
        pid: [{ required: true, message: '请选择上级片区' }],
        zoneName: [{ required: true, message: '请输入片区名称' }],
        zoneType: [{ required: true, message: '请选择区域类型' }],
        sellWater: [{ pattern: /^[0-9]+\.?[0-9]*$/, message: '请输入正整数或正小数' }],
        leakageRate: [
          { required: true, message: '请输入漏损率' },
          { pattern: /^[0-9]+\.?[0-9]*$/, message: '请输入正整数或正小数' },
        ],
        stepLength: [{ pattern: /^[0-9]+\.?[0-9]*$/, message: '请输入正整数或正小数' }],
        bottomTon: [{ pattern: /^[-+]?[0-9]+([.][0-9]+)?$/, message: '请输入正负整数或小数' }],
        nightTotalFlow: [{ pattern: /^[-+]?[0-9]+([.][0-9]+)?$/, message: '请输入正负整数或小数' }],
        geoJson: [],
      }
    },
  },
  methods: {
    getListIndex () {
      console.log(this.list)
    },

    chuli (n) {
      if (n != null && n.length !== 0) {
        n.map((item) => {
          item.children = this.chuli(item.children)
          if (item.level == 1) {
            this.treeDefaultExpandedKeys.push(item.id)
          }
        })
        return n
      } else {
        return n
      }
    },
    initLayerLevel () {
      this.$http
        .get('/pipe-network/zone-metering/level/options')
        .then(({ data }) => {
          this.layerLevelList = data
        })
    },
    handleLayerChange (val) {
      this.layerLeval = val
      this.leval = val
      const cql =
        this.leval === 0
          ? 'is_deleted = false'
          : `is_deleted = false and level = '${val}' and tenant_id = '${this.$store.state.user.info.tenantId}'`
      const currentLayer = {
        id: `zone_metering_management_showfq`,
        workspace: 'smart_water',
        dataSource: 'smart_water:zone_metering',
      }
      this.$refs.collectionMapRef.wmsFQLayers(currentLayer, cql)
    },
    showGISLayer (show, text) {
      this[show] = !this[show]
      this.isShowGW ? this[text] = '隐藏' : this[text] = '显示'
      this.$refs.collectionMapRef.showGISLayer(text, this[show])
    },
    showFQLayer () {
      this.isShowFQ = !this.isShowFQ
      if (!this.isShowFQ) {
        this.$refs.collectionMapRef.showFQLayer(this.isShowFQ)
      } else {
        this.$refs.collectionMapRef.getLayers(this.leval)
      }
    },
    // 获取数据
    getGeomeryData () { this.$refs.collectionMapRef.getGeomeryData() },
    // 删除
    deleteOne () { this.$refs.collectionMapRef.deleteOne() },
    // 撤销
    removeLastDraw () { this.$refs.collectionMapRef.removeLastDraw() },
    // 清除
    removeAllDraw () { this.$refs.collectionMapRef.removeAllDraw() },
    // 关闭
    handleCancel () { this.mapVisible = false },
    handleMapOk () {
      console.log('handleFormOk===')
      this.$refs.collectionMapRef.getGeomeryData()
      this.mapVisible = false
    },
    // 显示编辑弹窗
    showEditPopup () {
      this.mapVisible = true
      console.log()

      if (this.addOrUpdateForm.level == '') {
        this.addOrUpdateForm.level = 1
      }

      this.leval = this.addOrUpdateForm.level
      this.layerLeval = '第' + this.leval + '级'
    },
    // 汉字的数字
    numberParseChina (money) {
      // eslint-disable-next-line no-array-constructor
      var cnNums = new Array('零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十')
      return cnNums[money]
    },
    getAllTenant () {
      if (this.$store.state.user.info.systemAdmin) {
        this.$http
          .get('/manager/tenants/all')
          .then(({ data }) => {
            this.tenantList = data
          })
          .catch(({ e }) => {
            console.log(e)
          })
      }
    },
    addOrUpdateHandle (id) {
      this.addOrUpdateForm = {
        id: '',
        zoneId: '',
        pid: '',
        zoneName: '',
        zoneCode: '',
        zoneType: 2,
        geoJson: '',
        level: '',
        sellWater: '',
        stepLength: '',
        leakageRate: '',
        startUsing: '',
        nightTotalFlow: '',
        sort: '',
        isDmaZone: false,
        areaDma: 0
      }
      this.pipNetWorkList = []
      this.isUpdate = false
      this.pagination2 = {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
      }
      this.currentId = id
      // this.$refs.addOrUpdateForm.resetFields()
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        console.log(this.$refs.addOrUpdateForm)
        this.$refs.addOrUpdateForm.resetFields()
        if (id) {
          this.isUpdate = true
          this.$http
            .get(`${this.queryOneUrl}/${this.currentId}`)
            .then(({ data }) => {
              console.log(data);

              this.addOrUpdateForm = { ...this._updateForm(this.addOrUpdateForm, data) }
              console.log(this.addOrUpdateForm);

              this.selectId = data.id
              // this.getNetWorkList(data.id)
              // this.stabilizePipNetWorkList = data.pipNetWorkList
            })
            .catch(() => { })
        }
      })
    },
    changeFile (id) {
      console.log(id)
      this.id = id
    },
    customRequest (data) {
      // 上传提交
      const formData = new FormData()
      formData.append('file', data.file)
      this.saveFile(formData)
    },
    saveFile (formData) {
      this.dataListLoading = true
      this.axios({
        method: 'post',
        url: '/zone-metering/zone-metering/upload-point',
        headers: {},
        params: {
          id: this.id,
        },
        data: formData,
      })
        .then((response) => {
          if (response.code === 0) {
            this.queryList()
            this.$message.success(response.message)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
        .finally(() => {
          this.dataListLoading = false
        })
    },
    filterTree (list, id) {
      if (id && list) {
        let realList = []
        realList = list.map((l) => {
          return {
            ...l,
            selectable: l.id !== id,
            children: l.id === id ? this.filterTreetoSelected(l.children) : this.filterTree(l.children, id),
          }
        })
        return realList
      } else {
        return list
      }
    },
    filterTreetoSelected (list) {
      if (list) {
        return list.map((l) => ({ ...l, selectable: false, children: this.filterTreetoSelected(l.children) }))
      } else {
        return list
      }
    },
    setGeo (geoString) {
      console.log(geoString)
      // console.log(this.addOrUpdateForm.getFieldValue('geoJson'));
    },
    handleFormOk (e) {
      e.preventDefault()
      this.$refs.addOrUpdateForm.validate((valid) => {
        if (valid) {
          const params = { id: this.currentId, ...this.addOrUpdateForm }
          console.log(params)
          if (typeof params.areaDma === 'boolean') {
            params.areaDma = params.areaDma ? 1 : 0
          }
          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, params)
            .then((res) => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                this.$refs.addOrUpdateForm.resetFields()
                return this.$message.success(res.message)
              }
            })
            .catch(() => { })
        }
      })
    },
    pidChange (val) {
      console.log(val)
      if (val == 0) {
        this.addOrUpdateForm.level = 1
        this.layerLeval = '第' + 1 + '级'
        return
      }
      console.log(this.list)
      this.axios({
        method: 'get',
        url: '/zone-metering/zone-metering/' + val,
        headers: {},
      })
        .then((response) => {
          console.log(response)
          if (response.code === 0) {
            this.addOrUpdateForm.level = Number(response.data.level) + 1
            this.layerLeval = '第' + Number(response.data.level) + 1 + '级'
          }
        })
        .catch(function (error) {
          console.log(error)
        })
        .finally(() => {
          this.dataListLoading = false
        })
    },
    handleZoneData (zoneData) {
      console.log('Received zoneData:', zoneData)
      this.axios({
        method: 'post',
        url: '/zone-metering/zone-metering/update/tree',
        headers: {},
        data: zoneData,
      }).then((response) => {
        this.queryList()
      })
    },
    getFormGeoJson (message) {
      console.log(message);

      this.addOrUpdateForm.geoJson = message
      this.handleCancel()
    },
    modalFormOk () {
      this.selectedRows = []
      this.selectedRowsList = []
      this.queryList()
    },
  },
  watch: {
    treeData (val) {
      this.chuli(val)
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.f-q-x-z {
  width: 100px;
  margin-right: 10px;

  /deep/.ant-select-selection {
    color: #fff;
    background-color: #215b5b;
    border: none;
  }

  /deep/.ant-select-arrow {
    color: #fff;
  }
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}

.footer-toolbar {
  display: flex;
  justify-content: space-between;
  background: linear-gradient(to right,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0) 10%,
      rgba(35, 198, 200, 0.3) 20%,
      rgba(35, 198, 200, 0.4) 30%,
      rgba(35, 198, 200, 0.5) 40%,
      rgba(35, 198, 200, 0.8) 50%,
      rgba(35, 198, 200, 0.5) 60%,
      rgba(35, 198, 200, 0.4) 70%,
      rgba(35, 198, 200, 0.3) 80%,
      rgba(0, 0, 0, 0) 90%,
      rgba(0, 0, 0, 0) 100%);
}

.my-map-component {
  /deep/.ant-modal-footer {
    background-color: #21201e;
    padding: 0px;
  }

  // /deep/.ant-btn {
  //   color: #000000a6;
  //   background-color: #e1d8d8;
  // }

  .gjcd-btn-box {
    /deep/.ant-btn {
      border: none;
      color: #fff;
      background-color: #236363;
    }
  }
}
</style>
